import React from "react";
import DynamicUniversityPage from "../../../custom-components/DynamicUniversityPage";
import { gdGoenkaUniversityJson } from "./GdGoenkaUniversityJson";
import DynamicWhyChooseThisUniversitiesPage from "../../../custom-components/DynamicWhyChooseThisUniversityPage";
import UniversityKnowMore from "src/CountryPages/University/UniversityKnowMore";
import Location from "../../../custom-components/Location";
import DynamicUniversityDetails from "../../../custom-components/DynamicUniversityDetails";
import DynamicNationalitySelection from "../../../custom-components/DynamicNationalitySelection";

const GdGoenkaUniversity = () => {
  const { heading, backgroundImage, content } =
    gdGoenkaUniversityJson.BannerData;

  return (
    <>
      <DynamicUniversityPage
        heading={heading}
        backgroundImage={backgroundImage}
        content={content}
      />
      <DynamicUniversityDetails data={gdGoenkaUniversityJson.universityDetails} />
      <DynamicWhyChooseThisUniversitiesPage
        rankingsData={gdGoenkaUniversityJson?.WhyChooseThisUniversityPage}
      />
       <DynamicNationalitySelection data={gdGoenkaUniversityJson} />
      <Location
        header={gdGoenkaUniversityJson?.Location?.header}
        image={gdGoenkaUniversityJson?.Location.image}
        content={
          gdGoenkaUniversityJson?.Location?.content || "No content available"
        }
      />
      <UniversityKnowMore data={gdGoenkaUniversityJson?.KnowMore} />
    </>
  );
};

export default GdGoenkaUniversity;
